type BaseInputType = {
  name: string;
  label?: string;
  info?: string;
  required?: boolean;
  className?: string;
  customValidity?: string;
  type?: string;
  placeholder?: string;
  autoComplete?: string;
  defaultValue?: string | null | undefined | number;
  children?: React.ReactNode;
};

export default function Input<T extends BaseInputType>({
  name,
  label = "",
  info = "",
  required = false,
  className = "",
  customValidity = "",
  defaultValue = undefined,
  type = "",
  placeholder = "",
  autoComplete = "off",
  children = null,
  ...rest
}: T) {
  const inputProps = rest as React.InputHTMLAttributes<HTMLInputElement>;
  if (customValidity) {
    inputProps.onInvalid = (e) => e.currentTarget.setCustomValidity(customValidity);
    inputProps.onInput = (e) => e.currentTarget.setCustomValidity("");
  }

  return (
    <>
      {!!label && (
        <label className={`${required ? "required" : ""} mb-1 text-sky-800`} htmlFor={name}>
          {label}
          {!!info && <span className="ml-2 text-xs italic text-sky-800 opacity-30">{info}</span>}
        </label>
      )}
      {children ? (
        <div className={`mb-4 ${className}`}>{children}</div>
      ) : (
        <input
          className={`mb-4 rounded border border-sky-800 border-opacity-30 px-2 py-2 ${className}`}
          name={name}
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          defaultValue={defaultValue || undefined}
          {...inputProps}
        />
      )}
    </>
  );
}
